import { Watch, Mail, Phone, MapPin, Instagram, Facebook, Twitter } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-obsidian border-t border-white/5" data-testid="footer">
      <div className="px-6 md:px-12 lg:px-24 py-16">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center gap-3">
              <Watch className="w-8 h-8 text-gold-500" />
              <span className="font-serif text-2xl text-white tracking-tight">CHRONOS</span>
            </Link>
            <p className="text-white/50 text-sm leading-relaxed">
              Since 1892, crafting exceptional timepieces that define generations. Swiss precision meets timeless design.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-white/5 flex items-center justify-center text-white/60 hover:bg-gold-500 hover:text-black transition-all" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-white/5 flex items-center justify-center text-white/60 hover:bg-gold-500 hover:text-black transition-all" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-white/5 flex items-center justify-center text-white/60 hover:bg-gold-500 hover:text-black transition-all" aria-label="Twitter">
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Collections */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-gold-500 mb-6">Collections</h4>
            <ul className="space-y-4">
              {['Chronographs', 'Divers', 'Dress Watches', 'Pilot Watches', 'Grand Complications'].map((item) => (
                <li key={item}>
                  <a href="#collections" className="text-white/60 hover:text-gold-500 transition-colors text-sm">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-gold-500 mb-6">Services</h4>
            <ul className="space-y-4">
              {['Concierge Service', 'Watch Care', 'Warranty', 'Repairs & Restoration', 'Authentication'].map((item) => (
                <li key={item}>
                  <a href="#" className="text-white/60 hover:text-gold-500 transition-colors text-sm">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-gold-500 mb-6">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-white/60">
                <MapPin className="w-4 h-4 text-gold-500 mt-1 flex-shrink-0" />
                <span className="text-sm">42 Rue du Rhône<br />1204 Geneva, Switzerland</span>
              </li>
              <li className="flex items-center gap-3 text-white/60">
                <Phone className="w-4 h-4 text-gold-500" />
                <span className="text-sm">+41 22 123 4567</span>
              </li>
              <li className="flex items-center gap-3 text-white/60">
                <Mail className="w-4 h-4 text-gold-500" />
                <span className="text-sm">concierge@chronos.ch</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/5 px-6 md:px-12 lg:px-24 py-6">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/30 text-xs">
            © {currentYear} Chronos. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-white/30 hover:text-gold-500 text-xs transition-colors">Privacy Policy</a>
            <a href="#" className="text-white/30 hover:text-gold-500 text-xs transition-colors">Terms of Service</a>
            <a href="#" className="text-white/30 hover:text-gold-500 text-xs transition-colors">Cookie Settings</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
